import React from "react";
import Button from "components/button";
import UseContext from "hooks/useContext";
import LoadingButton from "../../components/button/loading";
import {isMissionConfirmationPage} from "pages/createMission/utils/missionSteps";

const FooterButton = ({ oC1, oC2, isLoading }) => {
    const { page, language } = UseContext();

    if (isMissionConfirmationPage(page)) {
        return isLoading ? (
            <LoadingButton color={"PRIMARY"} size={"LG"}>
                {language.getValue("missionCreation.wizard.creating", "Création de la mission")}
            </LoadingButton>
        ) : (
            <Button size={"LG"} onClick={oC2}>
                {language.getValue("missionCreation.wizard.create", "Créer la mission")}
            </Button>
        );
    }

    return (
        <Button size={"LG"} onClick={oC1}>
            {language.getValue("missionCreation.wizard.next", "Suivant")}
        </Button>
    );
};

export default FooterButton;
